import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import reportWebVitals from './reportWebVitals';
import {configureStore} from '@reduxjs/toolkit';
import {Provider} from 'react-redux';
import { portData } from './features/port';
import loginData  from './features/login';
import {injectStore} from './utils/axiosIstance';
import {combineReducers} from "redux";
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import thunk from 'redux-thunk'
import { persistStore } from 'redux-persist';
import App from './App';

import { Beforeunload } from 'react-beforeunload';

import secureSessionStorage from 'react-secure-storage';


// const reducers = combineReducers({
//     port: portData,
//     login: loginData,   
// });

// const persistConfig = {
//     key: 'root',
//     storage
// };

// const persistedReducer = persistReducer(persistConfig, reducers);

// console.log(`${process.env.REACT_APP_NAME} ${process.env.REACT_APP_VERSION}`)

// const store = configureStore({
//     reducer: persistedReducer,
//     devTools: process.env.NODE_ENV !== 'production',
//     middleware: [thunk]
// });


// const store = configureStore(store);


// injectStore(store);
// let persistor = persistStore(store);
console.log(secureSessionStorage);
const root = ReactDOM.createRoot(document.getElementById('root'));

const port = "8083";
const clientId = "remote_webp";
//const connectUrl = `mqtt://${host}:${port}`;

const id = sessionStorage.getItem('sessionRef')

const mqttOptions =  {
    clientId: id,
    clean: true,
    username: "remote_webp",
    password: "remote_webp"
};


console.log("in index isC", secureSessionStorage.getItem('isCtnrl'));
console.log("in index sessionRef", secureSessionStorage.getItem('sessionRef'));

root.render(
   
                <App />
   
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
